import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentMfaIntent } from '../app/auth-state';
import { LoginMfaPage } from '../modules/auth/ui/pages/LoginMfaPage';

export const Route = createFileRoute('/login-mfa')({
  beforeLoad: () => {
    if (!getCurrentMfaIntent()) {
      throw redirect({ to: '/login' });
    }
  },
  component: LoginMfaPage,
});
